import React, {useState, useEffect} from 'react'
import {motion, AnimatePresence} from 'framer-motion'
import {Link} from 'gatsby'
import './MenuPrimary.scss'

const Menu = ({menu, headerMenu}) => {

	const variants = {
		initial: {opacity: 0},
		animate: {opacity: 1},
		exit: {opacity: 0}
	}

	return(
		<motion.div variants={variants} initial="initial" animate="animate" exit="exit" className="MenuPrimary">
			<div className="menu">
				{
					headerMenu
					? 	<ul className="headerMenu">
							{
								headerMenu.map(headerMenuItem => {
									if(headerMenuItem.path !== '#') {
										return(
											<li key={headerMenuItem.id}>
												<Link className={headerMenuItem.cssClasses ? headerMenuItem.cssClasses.join(' ') : ''} to={headerMenuItem.path}>
													{headerMenuItem.label}
												</Link>
											</li>
										)
									} else {
										return(
											<li key={headerMenuItem.id}>
												<p>{headerMenuItem.label}</p>
											</li>
										)
									}
								})
							}
						</ul>
					: null
				}
				<p className="more-information">Mer informasjon</p>
				<ul className="menuItems">
					{
						menu.map(menuItem => {
							if(menuItem.path !== '#') {
								return(
									<li key={menuItem.id}>
										<Link className={menuItem.cssClasses ? menuItem.cssClasses : ''} to={menuItem.path}>
											{menuItem.label}
										</Link>
									</li>
								)
							} return null
						})
					}
				</ul>

				<div className="buttons">
					<a className="Button primary-white" href="//lovdata.no/pro/auth/login"><span>Logg inn</span></a>
				</div>
			</div>
			<div className="bg" />
		</motion.div>
	)
}

export default function MenuPrimary({menu, headerMenu}) {

	const [active, setActive] = useState(false)

	useEffect(() => {
		if(active) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'auto'
		}
		return () => {
			document.body.style.overflow = 'auto'
		}
	}, [active])

	return(
		<>
			<button className={`MenuPrimaryButton ${active ? 'active' : ''}`} onClick={() => { setActive(!active) }}>
				<span className={`hamburger hamburger--spin ${active ? 'is-active' : ''}`}>
					<span className="hamburger-box">
						<span className="hamburger-inner"></span>
					</span>
				</span>
				<span className="helper">{active ? 'Lukk meny' : 'Åpne meny'}</span>
			</button>
			<AnimatePresence>
				{
					active
					? <Menu menu={menu} headerMenu={headerMenu} />
					: null
				}
			</AnimatePresence>
		</>
	)
}